<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isUserWechatDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserCustomerEdit',
  isAutoComponent: true,
  data() {
    return {
      formAddUrl: '/modules/userWechat/userWechatUpdate',
      detailFormButtons: {
        title: '成为大客户',
        elements: [{ name: '提交', key: 'EDIT', action: 'EDIT', hidden: false, className: 'primary' },
          { name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '修改大客户',
        elements: [
          { name: '姓名',
            key: 'name',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 20, message: '姓名长度不能超过20', trigger: 'blur' }
            ] },
          { name: '手机号',
            key: 'phone',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 11, max: 11, message: '手机号格式不正确', trigger: 'blur' },
              { pattern: this.$wtValidator.ValidatorPhonePattern, message: '手机号格式不正确', trigger: 'blur' }
            ] },
          { name: '银行卡号',
            key: 'bankCar',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 20, message: '银行卡号长度不能超过20', trigger: 'blur' }
            ] },
          { name: '开户行',
            key: 'bankName',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 50, message: '开户行长度不能超过50', trigger: 'blur' }
            ] },
          { name: '其他',
            key: 'otherInfo',
            type: 'text',
            required: false,
            disabled: false,
            rules: [
              { min: 1, max: 100, message: '其他长度不能超过100', trigger: 'blur' }
            ] },
          { name: '身份证照片', key: 'idCardList', type: 'image', required: true, disabled: false, limit: 1 },
          { name: '营业执照', key: 'businessLicenseList', type: 'image', disabled: false, limit: 1 }]
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '修改大客户' }})
    if (this.detailFormData.idCard && this.detailFormData.idCard.length > 0) {
      const _idCardList = this.detailFormData.idCard.split(',')
      for (const item of _idCardList) {
        this.detailFormData.idCardList = [{ fileUrl: item }]
      }
    }
    this.detailFormData.businessLicenseList = [{ fileUrl: this.detailFormData.businessLicense }]
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      } else if (item.action === 'EDIT') {
        this.onAdd()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUserWechatAdd()
      }).catch(() => {
      })
    },
    requestUserWechatAdd() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      // const _idCard = []
      // for (const item of this.detailFormData.idCardList) {
      //   _idCard.push(item.fileUrl)
      // }
      if (this.detailFormData.businessLicenseList && this.detailFormData.businessLicenseList.length > 0) {
        sendData.businessLicense = this.detailFormData.businessLicenseList[0].fileUrl
      }
      sendData.idCard = this.detailFormData.idCardList[0].fileUrl
      delete sendData.idCardList
      delete sendData.businessLicenseList
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'refresh')
      })
    }
  },
  computed: {
    ...mapState({
      isUserWechatDetailLoading: state => state.userWechat.isUserWechatDetailLoading,
      detailFormData: state => state.userWechat.userWechatDetailData,
      customerId: state => state.userWechat.customerId
    })
  }
}
</script>
